import(/* webpackMode: "eager" */ "/app/src/app/[lng]/(use-auth)/blog/page.tsx");
